/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { REGISTER_PLACEHOLDER } from '@assetaccountant/core/http-token.interceptor';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { CustomField } from '../models/custom-field';
import { GetCustomFieldsQuery } from '../models/custom-fields/get-custom-fields.query';
import { UpdateCustomFields } from '../models/custom-fields/update-custom-fields';
import { OperationResponse } from '../models/generic/operation-response';
import { DeleteCustomFieldKey } from '../models/registers/delete-custom-field-key';
import { DeleteCustomFieldKeyLegacy } from '../models/registers/delete-custom-field-key-legacy';
import { GetCustomFieldKeysQuery } from '../models/registers/get-custom-field-keys.query';

@Injectable({
  providedIn: 'root',
})
export class CustomFieldApi {
  constructor(private http: HttpClient) {}

  deleteKey(command: DeleteCustomFieldKey): Observable<void> {
    return this.http.delete<void>(
      `${environment.servicesApiUrl}/api/v3/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/${command.objectType}/customfieldkey/${command.customFieldKey}`,
    );
  }

  /**
   * @deprecated Use new route
   */
  deleteKeyLegacy(command: DeleteCustomFieldKeyLegacy): Observable<void> {
    return this.http.delete<void>(
      `${environment.servicesApiUrl}/api/v3/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/customfieldkey/${command.customFieldKey}`,
    );
  }

  get(command: GetCustomFieldsQuery): Observable<OperationResponse<CustomField[]>> {
    return this.http.get<OperationResponse<CustomField[]>>(
      `${environment.servicesApiUrl}/api/v3/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/${command.objectType}/${command.objectId}/customfields`,
    );
  }

  getKeys(command: GetCustomFieldKeysQuery): Observable<OperationResponse<string[]>> {
    return this.http.get<OperationResponse<string[]>>(
      `${environment.servicesApiUrl}/api/v3/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/${command.objectType}/customfieldkeys`,
    );
  }

  /**
   * @deprecated Use new route
   */
  getKeysLegacy(registerId?: number | null): Observable<OperationResponse<string[]>> {
    return this.http.get<OperationResponse<string[]>>(
      `${environment.servicesApiUrl}/api/v3/registers/${registerId ?? REGISTER_PLACEHOLDER}/customfieldkeys`,
    );
  }

  update(command: UpdateCustomFields): Observable<void> {
    return this.http.post<void>(
      `${environment.servicesApiUrl}/api/v3/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/${command.objectType}/${command.objectId}/customfields`,
      command,
    );
  }
}
